<ng-container *ngIf="toastService.toast$ | async as toast">
  <ngb-toast
      *ngIf="toast.show"
      [autohide]="true"
      [delay]="toast.duration"
      class="toast"
      [class.toast-success]="toast.type === 'success'"
      [class.toast-warning]="toast.type === 'warning'"
      [class.toast-error]="toast.type === 'error'"
      (hide)="toastService.remove()"
      >
      <div class="toast-progress-bar" [style.animation-duration]="toast.duration + 'ms'"></div>
      <div class="toast-header">
        <i class="ic-font"
          [class.ic-info]="!toast.type"
          [class.ic-done]="toast.type === 'success'"
          [class.ic-warning]="toast.type === 'warning'"
          [class.ic-error]="toast.type === 'error'"
        ></i>
        <span class="toast-title"> {{toast.title}} </span>
      </div>
      <span *ngIf="toast.description" class="toast-description">{{toast.description}}</span>
      <div class="toast-footer">
        <button (click)='toastService.remove()' class="btn btn-clear">Ok</button>
      </div>
  </ngb-toast>
</ng-container>
